module.exports = __webpack_public_path__ + "img/img63.f6cd1d81.svg";